import * as ActionTypes from '../ActionTypes'


// Bucket
export const setBucketValue = (bucketData) => (dispatch) => {
  dispatch(setBucket(bucketData));
};

export const setBucket = (bucketData) => ({
  type: ActionTypes.SET_BUCKET,
  payload: bucketData
});

export const addToBucket = (bucketData) => ({
  type: ActionTypes.ADD_TO_BUCKET,
  payload: bucketData
});

export const addSnackbarToBucket = (bucketData) => ({
  type: ActionTypes.ADD_SNACKBAR_TO_BUCKET,
  payload: bucketData
});

